var $dtWZa$styledcomponents = require("styled-components");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FONTS", {
    enumerable: true,
    get: function get() {
        return $bebaee556f9a4756$exports.FONTS;
    }
});
Object.defineProperty(module.exports, "Theme", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.Theme;
    }
});
Object.defineProperty(module.exports, "border", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.border;
    }
});
Object.defineProperty(module.exports, "boxShadow", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.boxShadow;
    }
});
Object.defineProperty(module.exports, "boxShadowFocus", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.boxShadowFocus;
    }
});
Object.defineProperty(module.exports, "breakpoint", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.breakpoint;
    }
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.color;
    }
});
Object.defineProperty(module.exports, "colorSelector", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.colorSelector;
    }
});
Object.defineProperty(module.exports, "fontWeight", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.fontWeight;
    }
});
Object.defineProperty(module.exports, "layer", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.layer;
    }
});
Object.defineProperty(module.exports, "query", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.query;
    }
});
Object.defineProperty(module.exports, "typo", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.typo;
    }
});
Object.defineProperty(module.exports, "typoSelector", {
    enumerable: true,
    get: function get() {
        return $bb6a8a3022cc23ea$exports.typoSelector;
    }
});
var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $dtWZa$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});




//# sourceMappingURL=index.js.map
